import { render, staticRenderFns } from "./ProjectOverviewCard.vue?vue&type=template&id=9fe0d03e&scoped=true"
import script from "./ProjectOverviewCard.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectOverviewCard.vue?vue&type=style&index=0&id=9fe0d03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe0d03e",
  null
  
)

export default component.exports